import TableHeader from "containers/gstr2a2bNewEnhancement/Utility/TableHeader";
import React from "react";
import { ViewRecoHeaders } from "../constants";
import { setActiveTabViewReco } from "../action";
import { useDispatch, useSelector } from "react-redux";
import IssueWise from "./IssueWise/IssueWise";
import DocView from "./DocView/DocView";
import SupplierWise from "./SupplierWise/SupplierWise";
import DownloadReport from "./DownloadReport/DownloadReport";
import UploadReport from "./UploadReport/UploadReport";

const ViewReco = (props) => {
  const { handleSubmit } = props;
  const dispatch = useDispatch();

  const { activeTabViewReco } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  async function handleTabChange(id) {
    await dispatch(setActiveTabViewReco(id));
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          height: "3em",
          boxShadow: "0px 2px 3px 0px #8080805e",
          paddingRight: "5px",
        }}
      >
        <TableHeader
          handleTabChange={handleTabChange}
          columns={ViewRecoHeaders}
          activeTab={activeTabViewReco}
        />
      </div>
      <div>
        {activeTabViewReco === "1" && <IssueWise handleSubmit={handleSubmit} />}
        {activeTabViewReco === "2" && <DocView />}
        {activeTabViewReco === "3" && <SupplierWise  handleSubmit={handleSubmit}/>}
        {activeTabViewReco === "4" && <DownloadReport  handleSubmit={handleSubmit}/>}
        {activeTabViewReco === "5" && <UploadReport />}
      </div>
    </>
  );
};

export default ViewReco;
